<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'TodaysReturnsStatus',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
            main_icon:'fa-light fa-share',
                title: 'Returns Today',
                load_url: '/dashboards/TodaysReturns/',
                icon_data: [
                    {
//                        name: 'Total Returns',
                        name: 'To Pull',
                        text_color: '#2A9D8F',
                    },
                    {
//                        name: 'Split kit Returns',
                        name: 'To Pull - Split',
                        text_color: '#264653',
                    },
                    {
//                        name: 'Full Returns',
                        name: 'To Pull - Full',
                        text_color: '#F4A261',
                    },
                    {
//                        name: 'Returns Completed',
                        name: 'Complete',
                        text_color: '#E76F51',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>